import { P4 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  margin-bottom: 24px;

  flex-direction: column;
  ${QUERIES.tabletAndUp} {
    flex-direction: row;
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: ${themeStyle.radiusLarge};
  cursor: ${({ cursor }) => cursor || 'default'};
`;

export const Description = styled(P4)`
  margin-top: 8px;
  color: ${themeStyle.varInkMedium};
  font-style: italic;
  font-weight: ${themeStyle.fontRegular};
  text-align: center;
`;
